// extracted by mini-css-extract-plugin
export default {"title":"Documents_title__7BNa7","description":"Documents_description__IqHoM"};